import React from "react";

import { siteLocationPrefix } from "../../constants";
import { TestInput } from "./TestInput";
import * as styles from "./TestStyle.module.css";

export const TestAMSActions = () => (
  <div className={styles.pcAmsActionsWrapper}>
    <h3>Partner Center AMS Actions</h3>
    <TestInput
      actionURL={`${siteLocationPrefix}/test/setOGCUserOverrideForRoleAdding`}
      label="Set OCG Email to override on role adding process ('delete' to remove) "
      buttonText="set"
      actionName="ogcEmailOverride"
    />
    <br />
    <br />
  </div>
);
